import { SearchFilterTag } from '@/components';
import type {
  SharedSearchFormKeys,
  SharedSearchFormType,
} from '@/features/search/_utils/projects-search';
import { t } from '@/i18n';
import { type FC, useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useProjectsSearchFormProviderState } from '../ProjectsSearchAccordionProvider';

export const PaymentTag: FC<{ onResetPayment: () => void }> = ({
  onResetPayment,
}) => {
  const { control, setValue } = useFormContext<SharedSearchFormType>();
  const [corporateName, setCorporateName] = useState<string | undefined>(
    undefined,
  );
  const [isLoading, setIsLoading] = useState(true);
  const corporateNumber = useWatch({
    control,
    name: 'corporateNumber' satisfies SharedSearchFormKeys,
  });
  const { type } = useProjectsSearchFormProviderState();
  const watchedValues =
    type !== 'analysis'
      ? useWatch({
          control,
          name: [
            'sheetType',
            'fundSheetType',
            'skipAdministrativeReformTeamEvaluation',
          ],
        })
      : undefined;

  const [sheetType, fundSheetType, skipAdministrativeReformTeamEvaluation] =
    watchedValues ?? [];

  useEffect(() => {
    if (corporateNumber) {
      (async () => {
        // const res = await fetchGovernmentNumber({ corporateNumber });
        // setCorporateName(res.at(0)?.corporateName);
        setIsLoading(false);
      })();
    } else {
      setCorporateName(undefined);
      setIsLoading(false);
    }
  }, [corporateNumber]);

  if (sheetType === 'RS' && skipAdministrativeReformTeamEvaluation === 'true') {
    return null;
  }
  if (sheetType === 'KS' && fundSheetType !== 'standard') {
    return null;
  }

  if (!corporateName || isLoading) {
    return null;
  }

  return (
    <SearchFilterTag
      closable={true}
      label={`${t('payment-name')}: ${corporateName}`}
      onClose={() => {
        setValue('corporateNumber' satisfies SharedSearchFormKeys, null);
        onResetPayment();
      }}
    />
  );
};
